import React from "react";
import { styled } from "@mui/material/styles";
import Header from "./Header";
import Sidebar, { DrawerHeader } from "./Sidebar";
import { Box } from "@mui/material";
import { useTheme } from "@emotion/react";

const BoxContainer = styled(Box)({
  display: "flex",
});

const MainContent = styled("main")({
  flexGrow: 1,
  p: 3,
  // minHeight: "100vh",
});

// Create a custom theme using createTheme
export default function Layout({ children, title }) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const handleDrawer = () => {
    setOpen(!open);
  };

  return (
    <>
      <BoxContainer
        sx={{
          transition: "all 0.3s",
          [theme.breakpoints.up("xs")]: {
            padding: open ? "74px 20px 10px 260px" : "74px 20px 10px 20px",
          },
          [theme.breakpoints.up("lg")]: {
            padding: open ? "74px 20px 10px 260px" : "74px 20px 10px 90px",
          },
          display: "block",
          backgroundColor: theme.palette.background.default,
          overflow: "hidden",
        }}
      >
        <Header
          open={open}
          handleDrawer={handleDrawer}
          setOpen={setOpen}
          title={title}
        />
        <Sidebar open={open} setOpen={setOpen} />
        <MainContent>
          {/* <DrawerHeader /> */}
          <Box
            id="main_box"
            sx={{
              m: "0",
              backgroundColor: theme.palette.background.paper,
              borderRadius: "4px",
              padding: "20px",
              transition: "all 0.3s",
            }}
            onClick={() => setOpen(false)}
          >
            {children}
          </Box>
        </MainContent>
      </BoxContainer>
    </>
  );
}
